var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewpointImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 124,
    height: 124,
    rx: 4,
    fill: "#96969B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62 69.75C70.5604 69.75 77.5 62.8104 77.5 54.25C77.5 45.6896 70.5604 38.75 62 38.75C53.4396 38.75 46.5 45.6896 46.5 54.25C46.5 62.8104 53.4396 69.75 62 69.75Z",
    stroke: "white",
    strokeWidth: 4.33,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5078 83.3147C40.8884 79.1906 44.3126 75.7658 48.4364 73.3847C52.5602 71.0036 57.2381 69.75 62 69.75C66.7619 69.75 71.4398 71.0036 75.5636 73.3847C79.6874 75.7658 83.1116 79.1906 85.4922 83.3147",
    stroke: "white",
    strokeWidth: 4.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewpointImg);
export default __webpack_public_path__ + "static/media/viewpoint_img.cabde1541a42bcd94d8a784eaf3aa9de.svg";
export { ForwardRef as ReactComponent };